import { render, staticRenderFns } from "./AddDevice.vue?vue&type=template&id=16435760&scoped=true"
import script from "./AddDevice.vue?vue&type=script&lang=js"
export * from "./AddDevice.vue?vue&type=script&lang=js"
import style0 from "./AddDevice.vue?vue&type=style&index=0&id=16435760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16435760",
  null
  
)

/* custom blocks */
import block0 from "./AddDevice.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports